import { render, staticRenderFns } from "./HeaderCore.vue?vue&type=template&id=4bfed48a&scoped=true"
import script from "./HeaderCore.vue?vue&type=script&lang=js"
export * from "./HeaderCore.vue?vue&type=script&lang=js"
import style0 from "./HeaderCore.vue?vue&type=style&index=0&id=4bfed48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfed48a",
  null
  
)

export default component.exports